import React, { useState, useEffect, Fragment } from 'react'
import axios from 'axios'
import { Table } from 'reactstrap'

// Import API config object
import { tokenConfig } from '../utils/apiConfig'

// Import event list components
import AddEvent from '../components/EventList/AddEvent';
import UpdateEvent from '../components/EventList/UpdateEvent'

// Import Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';

import ManageSessions from '../components/EventList/ManageSessions';

const EventList = props => {
  const [events, setEvents] = useState([])
  // State tracker for Update Event modal
  const [updateEvent, setUpdateEvent] = useState(false)
  const [id, setId] = useState('')

  const [manageSessions, setManageSessions] = useState(false)

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  //Used to adjust view based on screen size
  useEffect(() => {
    function handleResize() {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //Getting all Events using axios
  useEffect(() => {
    getEvents()
  }, [])

  const getEvents = async () => {
    await axios.get('/api/events', tokenConfig())
      .then(res => setEvents(res.data))
      .catch(err => console.log(err))
  }

  const deleteEvent = async _id => {
    const confirm = window.confirm("Delete this Event?")
    if (!confirm) return console.log("Cancelled Request")
    await axios.delete(`/api/events/${_id}`, tokenConfig())
      .then(res => {
        setEvents(events.filter(event => event._id !== _id))
      })
      .catch(err => console.log(err))
  }

  const updateEventList = newEvent => {
    setEvents([...events, newEvent])
  }

  const insertUpdatedEvent = updatedEvents => {
    setEvents(updatedEvents)
  }
  return (
    <Fragment>
      <UpdateEvent
        toggle={e => setUpdateEvent(e)}
        updateEvent={updateEvent}
        _id={id}
        events={events}
        insertUpdatedEvent={insertUpdatedEvent}
      />
      <ManageSessions manageSessions={manageSessions} toggle={() => setManageSessions(!manageSessions)} eventId={id}/>
      <Table >
        <thead>
          <tr>
            <th style={{ width: "12.5%" }} className='rowAlign'>Name</th>
            {screenWidth > 1000 && <th style={{ width: "27%" }} className='rowAlign'>Description</th>}
            <th style={{ width: "8%" }} className='rowAlign'>Capacity</th>
            <th style={{ width: "8%" }} className='rowAlign'>Difficulty</th>
            <th style={{ width: "8%" }} className='rowAlign'>Location</th>
            <th style={{ width: "8%" }} className='rowAlign'>Status</th>
            <th style={{ width: "8%" }} className='rowAlign'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {events.map(({ _id, name, description, location, status, difficulty, capacity }) => {
            return (
              <tr key={_id}>
                <td className='rowAlign'>{name}</td>
                {screenWidth > 1000 && <td className='rowAlign'>{description}</td>}
                <td className='rowAlign'>{capacity}</td>
                <td className='rowAlign'>{difficulty}</td>
                <td className='rowAlign'><a href={location} target='_blank'>Click Me</a></td>
                <td className='rowAlign'>{status}</td>
                <td>
                  <center>
                    <FontAwesomeIcon
                      className='cursor'
                      icon={faEye}
                      onClick={() => {
                        setId(_id)
                        setManageSessions(true)
                      }}
                    />
                    <FontAwesomeIcon
                      color='blue'
                      className='cursor'
                      style={{ marginLeft: '6px' }}
                      icon={faEdit}
                      onClick={() => {
                        setId(_id)
                        setUpdateEvent(true)
                      }}
                    />
                    <FontAwesomeIcon
                      color='red'
                      className='cursor'
                      style={{ marginLeft: '6px' }}
                      icon={faTrash}
                      onClick={() => deleteEvent(_id)}
                    />
                  </center>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
      <AddEvent updateEventList={updateEventList} config={props.config} />
      <br />
      <br />
    </Fragment>
  )
}

export default EventList